import * as types from "./actionTypes";

const initialState = {
  resignationList: null,
  loading: false,
  error: null,
  success: false, // <-- add success flag
};

const employeeResignationReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_EMPLOYEE_RESIGNATION:
    case types.SAVE_EMPLOYEE_RESIGNATION:
    case types.SAVE_EMPLOYEE_REJOIN:
      return {
        ...state,
        loading: true,
        error: null,
        success: false, // reset success on new requests
      };

    case types.FETCH_EMPLOYEE_RESIGNATION_SUCCESS:
      return {
        ...state,
        loading: false,
        resignationList: action.payload?.data,
        success: false, // fetch doesn't change success
      };

    case types.SAVE_EMPLOYEE_RESIGNATION_SUCCESS:
    case types.SAVE_EMPLOYEE_REJOIN_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        success: true, // set success true only for save actions
      };

    case types.EMPLOYEE_RESIGNATION_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: false, // failure resets success
      };

    default:
      return state;
  }
};

export default employeeResignationReducer;
